import { atom } from 'recoil';

export const modalOpenErrorAtom = atom({
  key: 'modalOpenErrorAtom',
  default: false,
});
